module.exports.responsiveSlotDefinitions = [
  {
    name: 'leaderboard',
    sizeMappings: [
      {
        viewport: [ 1023, 0 ], // at least 1023 px wide (Desktop)
        adSizes: [
          [ 970, 250 ],
          [ 728, 90 ]
        ]
      },
      {
        viewport: [ 767, 0 ], // at least 767 px wide (Tablet)
        adSizes: [
          [ 728, 90 ]
        ]
      },
      {
        viewport: [ 0, 0 ], // at least 0 px wide (Mobile)
        adSizes: [
          [ 300, 250 ]
        ]
      }
    ]
  },
  {
    name: 'leaderboard-no-mobile',
    sizeMappings: [
      {
        viewport: [ 1023, 0 ], // at least 1023 px wide (Desktop)
        adSizes: [
          [ 970, 250 ],
          [ 728, 90 ]
        ]
      },
      {
        viewport: [ 767, 0 ], // at least 767 px wide (Tablet)
        adSizes: [
          [ 728, 90 ]
        ]
      },
      {
        viewport: [ 0, 0 ], // at least 0 px wide (Mobile)
        adSizes: []
      }
    ]
  },
  {
    name: 'mpu',
    sizeMappings: [
      {
        viewport: [ 0, 0 ], // at least 0 px wide (Mobile)
        adSizes: [
          [ 300, 250 ],
          [ 300, 600 ]
        ]
      }
    ]
  },
  {
    name: 'mpu-no-mobile',
    sizeMappings: [
      {
        viewport: [ 767, 0 ], // at least 767 px wide (Tablet)
        adSizes: [
          [ 300, 250 ],
          [ 300, 600 ]
        ]
      },
      {
        viewport: [ 0, 0 ], // at least 0 px wide (Mobile)
        adSizes: []
      }
    ]
  },
  {
    name: 'mpu-breakout',
    sizeMappings: [
      {
        viewport: [ 1023, 0 ], // at least 1023 px wide (Desktop)
        adSizes: [
          [ 970, 250 ],
          [ 728, 90 ]
        ]
      },
      {
        viewport: [ 767, 0 ], // at least 767 px wide (Tablet)
        adSizes: [
          [ 728, 90 ],
          [ 300, 250 ]
        ]
      },
      {
        viewport: [ 0, 0 ], // at least 0 px wide (Mobile)
        adSizes: [
          [ 300, 250 ]
        ]
      }
    ]
  },
  {
    name: 'leaderboard-mobile-only',
    sizeMappings: [
      {
        viewport: [ 0, 0 ], // at least 0 px wide (Mobile)
        adSizes: [
          [ 320, 50 ]
        ]
      },
      {
        viewport: [ 699, 0 ], // at least 699 px wide (Tablet)
        adSizes: [
          []
        ]
      }
    ]
  }
];
